import React from 'react';
import ArtworkListItem from './ArtworkListItem';
import Col from 'react-bootstrap/Col';
import './artwork.scss';
import Loading from '../Loading/Loading';
import { useLanguage } from '../../LanguageContext';

const ArtworkList = ({ artworks, currentIndex, setActiveArtwork, loading, onHoverArtwork }) => {
  const { selectedLanguage } = useLanguage();
  const isEmpty = !artworks || artworks.length === 0;

  return (
    <Col className="text-left custumListCont">
      {loading ? (
        <Loading />
      ) : isEmpty ? (
        <div className="text-center text-muted p-4">
          {selectedLanguage === 'it'
            ? 'Nessun risultato trovato. Prova a riformulare la ricerca.'
            : 'No results found. Try rephrasing your search.'}
        </div>
      ) : (
        <ul className="list-group artworkResultList">
          {artworks.map(
            (artwork, index) =>
              artwork && (
                <ArtworkListItem
                  key={index}
                  artwork={artwork}
                  isActive={currentIndex === index}
                  handleClick={() => setActiveArtwork(artwork, index)}
                  onHover={onHoverArtwork}
                />
              )
          )}
        </ul>
      )}
    </Col>
  );
};

export default ArtworkList;
